export default __webpack_public_path__ + "static/media/moneygram.713b45e2.svg";